/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';
import { capitalize } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectMembership, unselectMembership } from 'reducers/peopleTables';
import Buttons from 'components/Buttons.jsx';
import Checkbox from 'components/Checkbox.jsx';
import Group from 'entities/Group';
import GroupMembership from 'entities/GroupMembership';
import Timestamp from 'components/Timestamp.jsx';
import UserActionsMenuButton from 'user/components/UserActionsMenuButton.jsx';
import ClickEventTrigger from 'components/ClickEventTrigger.jsx';

type Props = {
  isSelected: boolean,
  group: Group,
  disabled?: boolean,
  hasSelection: boolean,
  membership: GroupMembership,
  selectMembership: (groupId: number, membership: GroupMembership) => any,
  unselectMembership: (groupId: number, membership: GroupMembership) => any,
}

import './styles/PeopleTableRow.scss';

class PeopleTableRow extends React.Component {
  props: Props;

  onClick = () => {
    const fn = this.props.isSelected
      ? this.props.unselectMembership
      : this.props.selectMembership;

    fn(this.props.group.id, this.props.membership);
  }

  stopPropagation = (e: any) => e.stopPropagation();

  render() {
    const { membership, group } = this.props;

    const classes = cx('PeopleTableRow', {
      'PeopleTableRow--enabled': !this.props.disabled,
      'PeopleTableRow--selected': this.props.isSelected,
      'PeopleTableRow--hasSelection': this.props.hasSelection,
    });

    const organizationAffiliation = membership.getOrgAffiliationView();
    const roles = organizationAffiliation
      ? (organizationAffiliation.roles.map(capitalize).join(', ') || 'No role')
      : undefined;

    const onClick = this.props.disabled ? undefined : this.onClick;

    return (
      <ClickEventTrigger eventElementName="multiselect_user_row">
        <tr className={classes} onClick={onClick}>
          <td className="PeopleTableRow-avatarCheckbox">
            <Checkbox
              checked={this.props.isSelected}
              className="PeopleTableRow-checkbox"
            />
          </td>
          <td>
            {membership.getName()}
          </td>
          {roles &&
            <td>
              {roles}
            </td>
          }
          <td>
            <Timestamp date={membership.getCreatedAt()} format="long" />
          </td>
          <td className="PeopleTableRow-actions">
            {!this.props.hasSelection &&
              <Buttons align="right">
                <UserActionsMenuButton
                  className="GroupMembersTabListItem-actionButton"
                  tooltip={this.props.disabled ? undefined : 'More Actions'}
                  tooltipPlacement="top"
                  level="text"
                  isAdminView
                  disabled={this.props.disabled}
                  groupToAdmin={group}
                  groupMembership={membership}
                  buttonSize="xxsmall"
                  glyphSize="medium"
                  showChangeRole={membership.hasPermission('can_change_role')}
                  showRemoveFromSchool={membership.hasPermission('can_remove_from_org')}
                  showGetTranscript={membership.hasPermission('can_request_message_history')}
                  handleClick={this.stopPropagation}
                  subscriber={membership.getSubscriber()}
                />
              </Buttons>
            }
          </td>
        </tr>
      </ClickEventTrigger>
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  const table = state.peopleTables.get(props.group.id);

  return {
    hasSelection: table.selectedMemberships.size > 0,
    isSelected: table.selectedMemberships.has(props.membership.id),
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ selectMembership, unselectMembership }, dispatch);
}

export { PeopleTableRow };
export default connect(mapStateToProps, mapDispatchToProps)(PeopleTableRow);



// WEBPACK FOOTER //
// ./src/components/PeopleTableRow.jsx